import React, { useCallback, forwardRef } from 'react'

import { Switch as ChakraSwitch, SwitchProps as ChakraSwitchProps } from '@chakra-ui/core'

export interface SwitchProps extends ChakraSwitchProps {
  onChangeValue?: (any) => void
}

export const Switch = forwardRef(({ onChange, onChangeValue, ...restProps }: SwitchProps, ref) => {
  const handleChange = useCallback(
    event => {
      onChange && onChange(event)
      onChangeValue && onChangeValue(event.target.checked)
    },
    [onChange, onChangeValue],
  )

  return <ChakraSwitch ref={ref} onChange={handleChange} {...restProps} />
})

export default Switch
